<template>
    <div class="row gx-0">
    <a role='button' class="row gx-0" :data-bs-target="target" data-bs-toggle="collapse">
        <div class="col-1 text-center align-items-center justify-content-center`">
            <font-awesome-icon :icon="icon"/>
        </div>
        <slot name="header"/>
    </a>
    <slot name="dropdown"/>
    </div>
</template>
<script>
export default {
    name: 'dropdown-header',
    props: {
        open: {
            type : Boolean
        },
        target: {
            type: String
        }
    },
    computed: {
        icon() {
            return this.open ? 'caret-down' : 'caret-right';
        }
    }
}
</script>

<style scoped lang="scss">
</style>